import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DatetimeLocalPipePipe } from './datetime-local/datetime-local-pipe.pipe';
import { MomentPipePipe } from './moment-pipe/moment-pipe.pipe';

@NgModule({
  declarations: [DatetimeLocalPipePipe, MomentPipePipe],
  imports: [CommonModule],
  exports: [DatetimeLocalPipePipe, MomentPipePipe],
})
export class CorePipesModule {}
